import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import potonganKeterlambatanProyekService from "../../services/potonganKeterlambatanProyekService";

export const initialState = {
    loading_potongan_keterlambatan_proyek: false,
    data_potongan_keterlambatan_proyek: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPotonganeterlambatanProyek = createAsyncThunk('potongan_keterlambatan_proyek/data',async (data, { rejectWithValue }) => {
    try {
        const response = await potonganKeterlambatanProyekService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const potonganKeterlambatanProyekSlice = createSlice({
    name: 'potongan_keterlambatan_proyek',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_potongan_keterlambatan_proyek = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPotonganeterlambatanProyek.fulfilled, (state, action) => {
                state.loading_potongan_keterlambatan_proyek = false
                state.data_potongan_keterlambatan_proyek = action.payload??[]
            })
            .addCase(getDataPotonganeterlambatanProyek.pending, (state) => {
                state.loading_potongan_keterlambatan_proyek = true
            })
            .addCase(getDataPotonganeterlambatanProyek.rejected, (state, action) => {
                state.loading_potongan_keterlambatan_proyek = false
                state.data_potongan_keterlambatan_proyek = action.payload
            })

    },
})

export const {
    showLoading,
} = potonganKeterlambatanProyekSlice.actions

export default potonganKeterlambatanProyekSlice.reducer
